import { format, parseISO } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import Options from '../options'
import { getTranslationKey } from '../../../../../../../../../enum/courseModalities.enum'
import { useMemo } from 'react'

interface UseColumnsProps {
  onDelete: (id: number, name: string) => void
  onDownload: (id: number) => void
}

export function useColumns({ onDelete, onDownload }: UseColumnsProps) {
  const { t } = useTranslation()
  type Column = {
    title: string
    key: keyof ExternalCourseModelAPI | 'action'
    sorteable?: boolean
    width?: number
    render?: (...data: any) => any
  }

  const formatDate = (date?: string) => {
    if (date) {
      try {
        return format(parseISO(date), 'dd/MM/yyyy')
      } catch {
        return ''
      }
    }
    return ''
  }
  const prefix = 'administration.externalCourses.attributes'
  const prefixColumns = 'administration.externalCourses.list.table.columns'

  const columns: Column[] = useMemo(
    () => [
      {
        title: t(`${prefix}.name`),
        key: 'name',
        sorteable: true,
        render: (name, { code }) => {
          return (
            <div>
              {name} <span style={{ color: '#aaa9a9' }}>({code})</span>
            </div>
          )
        },
      },
      {
        title: t(`${prefix}.participants`),
        key: 'participants',
        width: 170,
        sorteable: true,
        render: (participant) =>
          t(`${prefixColumns}.participants`, { count: participant }),
      },
      {
        title: t(`${prefix}.modality`),
        key: 'modality',
        width: 150,
        sorteable: true,
        render: (modality) => {
          const key = getTranslationKey(modality)
          return t(`${prefixColumns}.modalities.${key}`)
        },
      },
      {
        title: t(`${prefix}.startDate`),
        key: 'startDate',
        width: 120,
        sorteable: true,
        render: (date) => formatDate(date),
      },
      {
        title: t(`${prefix}.endDate`),
        key: 'endDate',
        width: 140,
        sorteable: true,
        render: (date) => formatDate(date),
      },
      {
        title: t(`${prefix}.institution`),
        sorteable: true,
        key: 'institution',
        width: 80,
      },
      {
        title: t(`${prefix}.additionalCode`),
        sorteable: true,
        key: 'additionalCode',
        width: 80,
      },
      {
        title: '',
        key: 'action',
        width: 100,
        render: (
          id: ExternalCourseModelAPI['id'],
          externalCourse: ExternalCourseModelAPI
        ) => (
          <Options
            externalCourse={externalCourse}
            onDelete={() => onDelete(id, externalCourse.name)}
            onDownload={() => onDownload(id)}
          />
        ),
      },
    ],
    [t, onDelete, onDownload]
  )
  return columns
}
